module.exports = __webpack_public_path__ + "static/media/popup.bb1af511.png";